import { SharedState } from '@trello/shared-state';
import { getNotificationSeenStateGroupCount } from './notificationSeenState';
// eslint-disable-next-line no-restricted-imports
import {
  NotificationGroupModel,
  NotificationsCountModel,
} from 'app/gamma/src/types/models';

export const notificationsState = new SharedState<{
  notificationGroups: NotificationGroupModel[];
  unreadCount: NotificationsCountModel;
  seenUnreadCount: NotificationsCountModel;
}>({
  notificationGroups: [],
  unreadCount: {},
  // eslint-disable-next-line @trello/no-module-logic
  seenUnreadCount: getNotificationSeenStateGroupCount(),
});
